module.exports = __webpack_public_path__ + "static/img/liveNone.57d44974.jpg";